import React  from 'react';
import { Grid, TextField } from '@mui/material'
import { useRecoilValue } from 'recoil';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom';

const LandlineField = () => {
    const { handleChange } = useSavePatient();
    const { uswFonoFijo1 } = useRecoilValue(valuesFormRegisterState);
    const { uswFonoFijo1: errorUswFonoFijo1, uswCodFonoFijo1: errorUswCodFonoFijo1 } = useRecoilValue(errorsFormRegisterState);

    return (
        <>
            <Grid item md={12} xs={12}>
                <InputLabelCustom text="Teléfono fijo" />
                <TextField
                    id="input-telefonofijo"
                    size="small"
                    error={errorUswCodFonoFijo1 && errorUswFonoFijo1.length > 0 ? true : false}
                    helperText={errorUswFonoFijo1 && errorUswFonoFijo1.length > 0 ? `${errorUswFonoFijo1.join("\n")}` : ''}
                    style={{ width: '100%' }}
                    name="uswFonoFijo1"
                    type="text"
                    value={uswFonoFijo1 || ""}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        maxLength: 9
                    }}
                    variant="outlined"
                    onChange={handleChange}
                    autoComplete="off"
                    placeholder='Ej: 412872958'
                />
            </Grid>
        </>
    )
}

export default LandlineField
